import { render, staticRenderFns } from "./upload-img.vue?vue&type=template&id=07d8a9fe&scoped=true&"
import script from "./upload-img.vue?vue&type=script&lang=js&"
export * from "./upload-img.vue?vue&type=script&lang=js&"
import style0 from "./upload-img.vue?vue&type=style&index=0&id=07d8a9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8a9fe",
  null
  
)

export default component.exports